// @tennis-matches/services/api/fetch-api-with-auth
// Same-origin /api/* mit Supabase-Bearer (+ apikey) und 401-Retry.

import { resolveApiAuthHeaders } from "./api-auth-headers.js";
import { resolveApiUrl } from "./get-api-base-url.js";

function __asStr(x) {
  return String(x ?? "").trim();
}

/**
 * @param {string} path
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */
export async function fetchApiWithAuth(path, init = {}) {
  const apiPath = __asStr(path);
  if (!apiPath) throw new Error("missing-api-path");

  const doFetch = async (headers) =>
    fetch(resolveApiUrl(apiPath), {
      ...init,
      headers: { ...(init.headers || {}), ...headers },
    });

  let auth = await resolveApiAuthHeaders();
  if (!auth.ok) {
    return new Response(
      JSON.stringify({ ok: false, reason: auth.reason || "no-auth" }),
      {
        status: 401,
        headers: { "Content-Type": "application/json" },
      },
    );
  }

  let response = await doFetch(auth.headers);
  if (response.status === 401) {
    auth = await resolveApiAuthHeaders({ forceRefresh: true });
    if (!auth.ok) {
      return new Response(
        JSON.stringify({ ok: false, reason: auth.reason || "no-auth" }),
        {
          status: 401,
          headers: { "Content-Type": "application/json" },
        },
      );
    }
    response = await doFetch(auth.headers);
  }

  return response;
}
